import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=5ecafd76&scoped=true"
import script from "./DetailDialog.vue?vue&type=script&lang=js"
export * from "./DetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailDialog.vue?vue&type=style&index=0&id=5ecafd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecafd76",
  null
  
)

export default component.exports